export default __webpack_public_path__ + "static/media/Dhillon1.1be8fac3.jpg";